// extracted by mini-css-extract-plugin
module.exports = {"label":"Label-module--label--2cqWk"};